import { ConfluencePageAri } from '@atlassian/ari/confluence/page';
import { getCloudId } from '@databases/database-state';
import {
  type BlogpostReference,
  type OptionalCreatePage,
  type PageReference
} from '@databases/types/confluence';

export const getConfluencePageAriFromContentRef = (
  content:
    | PageReference
    | BlogpostReference
    | OptionalCreatePage
    | { _id: string }
    | { contentId: string }
): string | undefined => {
  let ari: string | undefined = undefined;
  if ('ari' in content && content.ari) {
    ari = content.ari;
  } else if ('contentId' in content && typeof content.contentId === 'string') {
    ari = ConfluencePageAri.create({
      siteId: getCloudId() || '',
      pageId: content.contentId
    }).toString();
  }

  return ari;
};

export const createContentARI = (contentType: string, contentId: string) => {
  const siteId = getCloudId();
  if (!siteId || contentType !== 'page') {
    return;
  }

  return ConfluencePageAri.create({
    siteId,
    pageId: contentId
  }).toString();
};
